export const role = {
  administrator: "超级管理员",
  driver: "司机",
  permission: "权限",
  permissions: "的权限",
  role: "角色",
  users: "账号总数",
};
